import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { connect } from "react-redux";
import moment from "moment";
import ClearIcon from "@material-ui/icons/Clear";
import { useInterval } from "../../utils/KpsUtils.js";

function JobProgress(props) {
  const { t } = useTranslation();
  const [status, setStatus] = useState(null);
  const [dateIndexed, setDateIndexed] = useState(null)
  const [intervalSinceIndexed, setIntervalSinceIndexed] = useState(null)
  const [recentlyIndexed, setRecentlyIndexed] = useState(false)

  useEffect(() => {
    props.runningJobs && Array.isArray(props.runningJobs) &&
      setStatus(props.runningJobs.filter(j => (props.triggerName && props.triggerName === j.triggerName) || j.sourceId === props.sourceId)[0])
  }, [props.runningJobs])

  useEffect(() => {
    status && status !== null && 
      status.sourceReindexComplete && 
        recentIndexProgess()
    setDateIndexed(status && status !== null && status.sourceReindexComplete ? status.sourceReindexComplete : props.dateIndexed)
  }, [props.dateIndexed, status])

  useInterval(() => {
    recentIndexProgess()
    setIntervalSinceIndexed(moment(dateIndexed).fromNow())
  }, 2000);

  const recentIndexProgess = () => {
    let showProgress = status && 
      status.sourceReindexComplete 
        ? moment.duration(moment(new Date()).diff(status.sourceReindexComplete)).asSeconds() < 3
        : false
    setRecentlyIndexed(showProgress)
  }

  let actualStatus = props.status ? props.status : status;

  if (
    !actualStatus ||
    (actualStatus &&
      (!actualStatus.jobProgress || actualStatus.jobProgress.total === 0 || 
        (actualStatus.jobProgress.current === actualStatus.jobProgress.total && !recentlyIndexed )))
  ) {
    return dateIndexed ? <>{intervalSinceIndexed}</> : <ClearIcon/>;
  } else {
    let current = actualStatus.jobProgress.current;
    let total = actualStatus.jobProgress.total;
    let percent = Math.round((current / total) * 100);
    return ( 
      <div>
        <Typography>{`${current} / ${total} items (${percent}%)`}</Typography>
        <LinearProgress variant="determinate" value={percent} />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  runningJobs: state.admin.runningJobs,
})
export default connect(
  mapStateToProps,
  null
)(JobProgress);
